module.exports = __webpack_public_path__ + "static/img/dld_insight_group_2025.031eb7f.jpg";